import React from 'react';
import i18n from 'i18next';

import { Typo } from 'uikit/content';

import { InfiniteScrollList } from '@/exceed';

import { fetchLiveVideos } from '../api';

import VideosBreadCrumbs from './videosBreadCrumbs';
import VideosInfiniteListItem from './videosInfiniteListItem';
import getVideoBreadcrumbs from '../helpers/getVideoBreadcrumbs';

import styles from '../styles/liveVideos.module.scss';

const LiveVideos = () => (
  <>
    <VideosBreadCrumbs breadcrumbs={getVideoBreadcrumbs()} shouldShowAllAsActive />
    <div className={styles.body}>
      <Typo className={styles.title} variant="d07">
        {i18n.t('live-and-upcoming')}
      </Typo>
      <InfiniteScrollList
        emptyStateTitle={i18n.t('upcoming-empty-title')}
        emptyStateBody={i18n.t('upcoming-empty-body')}
        queryKey="liveVideos"
        queryFn={fetchLiveVideos}
        components={{
          ListItem: VideosInfiniteListItem,
        }}
      />
    </div>
  </>
);

LiveVideos.propTypes = {};

export default React.memo(LiveVideos);
